module.exports = __webpack_public_path__ + "static/right_0-14c4017472f1853b794a3019a2f91881.jpg";